// src/pages/Company/BlogPage.js
import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box, Divider, Grid, Card, CardContent, CardMedia, Button, Chip, Avatar, Stack } from '@mui/material';
import { CalendarToday, Person, ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock blog posts – replace with API call later
    const mockPosts = [
      {
        id: 1,
        title: 'How AI is Transforming Procurement',
        excerpt: 'Discover how artificial intelligence is reshaping supply chain management and vendor selection.',
        image: null,
        author: 'Jane Smith',
        date: new Date('2026-04-10').toISOString(),
        category: 'Technology',
      },
      {
        id: 2,
        title: '5 Tips for Writing Effective Problem Statements',
        excerpt: 'Learn how to articulate your business challenges to attract the best solutions.',
        image: null,
        author: 'John Doe',
        date: new Date('2026-04-05').toISOString(),
        category: 'Best Practices',
      },
      {
        id: 3,
        title: 'Why Supplier Diversity Matters',
        excerpt: 'The business case for including diverse suppliers in your procurement strategy.',
        image: null,
        author: 'Alice Johnson',
        date: new Date('2026-03-28').toISOString(),
        category: 'Industry Insights',
      },
    ];
    setPosts(mockPosts);
    setLoading(false);
  }, []);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  if (loading) {
    return (
      <Container sx={{ py: 6 }}>
        <Paper sx={{ p: 4 }}><Typography>Loading...</Typography></Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Rengigs Blog
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Insights, updates, and stories from the Rengigs ecosystem.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Grid container spacing={4}>
          {posts.map((post) => (
            <Grid item xs={12} md={6} key={post.id}>
              <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={post.image || 'https://via.placeholder.com/400x200?text=Rengigs+Blog'}
                  alt={post.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Chip label={post.category} size="small" sx={{ mb: 2, bgcolor: RENGIGS.light, color: RENGIGS.green }} />
                  <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                    {post.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {post.excerpt}
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <Person fontSize="small" color="disabled" />
                      <Typography variant="caption" color="text.secondary">{post.author}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <CalendarToday fontSize="small" color="disabled" />
                      <Typography variant="caption" color="text.secondary">{formatDate(post.date)}</Typography>
                    </Stack>
                  </Stack>
                  <Button component={Link} to={`/blog/${post.id}`} endIcon={<ArrowForward />} sx={{ color: RENGIGS.green }}>
                    Read More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Want to contribute? Contact our editorial team at <strong>blog@rengigs.com</strong>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default BlogPage;